import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import Install from "./pages/Install";
import Methodology from "./pages/Methodology";
import RoomSizePage from "./pages/RoomSizePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import GuidePage from "./pages/GuidePage";
import GuidesIndex from "./pages/GuidesIndex";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import ProductsIndex from "./pages/ProductsIndex";
import ProductPage from "./pages/ProductPage";
import NotFound from "./pages/NotFound";
import Corrections from "./pages/Corrections";
import Editorial from "./pages/Editorial";
import Resources from "./pages/Resources";
import { useServiceWorkerUpdate } from "./hooks/useServiceWorkerUpdate";

const queryClient = new QueryClient();

function AppContent() {
  useServiceWorkerUpdate();
  
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/install" element={<Install />} />
      <Route path="/methodology" element={<Methodology />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/corrections" element={<Corrections />} />
      <Route path="/editorial" element={<Editorial />} />
      <Route path="/resources" element={<Resources />} />
      
      {/* Blog */}
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      
      {/* Products */}
      <Route path="/products" element={<ProductsIndex />} />
      <Route path="/products/:id" element={<ProductPage />} />
      
      {/* Programmatic SEO: Guide Pages */}
      <Route path="/guides" element={<GuidesIndex />} />
      <Route path="/guide/:slug" element={<GuidePage />} />
      
      {/* Programmatic SEO: Room Size Pages (/200-sq-ft) and Room Type Pages (/bedroom) */}
      <Route path="/:size" element={<RoomSizePage />} />
      
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
